import {createSuppression} from '@resurs-internal/rb-app-api/helpers/storage/suppression';

const TRUSTPILOT_REVIEW_KEY = 'trustpilotReviewKey';

export const trustpilotReview = createSuppression({
  get: () => localStorage.getItem(TRUSTPILOT_REVIEW_KEY),
  set: (value) => localStorage.setItem(TRUSTPILOT_REVIEW_KEY, value),
  remove: () => localStorage.removeItem(TRUSTPILOT_REVIEW_KEY),
});
